var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "73px",
    height: "44px",
    viewBox: "0 0 73 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D03BC8D1-C64C-48CF-9A1C-F49B157D7B12") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Assets",
    transform: "translate(-53.000000, -58.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-1",
    transform: "translate(49.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    x: 1,
    y: 3,
    width: 78,
    height: 55
  }), /*#__PURE__*/React.createElement("g", {
    id: "Screens-icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2486373,45.1994566 C23.2658939,48.4486048 12.8011754,64.3724512 5.00177716,38.9919472 C0.642885614,24.8074086 16.0780438,12.6177585 33.7308587,8.21432615 C75.9330209,-2.31285421 79.4571767,29.1295405 74.9587723,40.2412034 C70.460368,51.3528662 61.2313807,41.9503085 42.2486373,45.1994566 Z",
    id: "Bacground",
    fill: "#F2FBFF",
    fillRule: "nonzero",
    transform: "translate(40.353284, 29.601909) rotate(190.000000) translate(-40.353284, -29.601909) "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    stroke: "#153454",
    strokeWidth: 1.0206,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 16.6267441,
    y: 16.177706,
    width: 47.0456684,
    height: 30.769894,
    rx: 2.0412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4485162,16.6588365 L61.8489642,16.6588365 C62.6005132,16.6588365 63.2097642,17.2680874 63.2097642,18.0196365 L63.2097642,22.5811072 L17.0877162,22.5811072 L17.0877162,18.0196365 C17.0877162,17.2680874 17.6969671,16.6588365 18.4485162,16.6588365 Z",
    id: "Rectangle-11",
    fill: "#E7F1F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4517569,16.6588365 L61.8455725,16.6588365 C62.5971215,16.6588365 63.2063725,17.2680874 63.2063725,18.0196365 L63.2063725,19.1940574 L17.0909569,19.1940574 L17.0909569,18.0196365 C17.0909569,17.2680874 17.7002078,16.6588365 18.4517569,16.6588365 Z",
    id: "Rectangle-11",
    fill: "#71B6FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    stroke: "#153454",
    strokeWidth: 1.0206,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    x: 60.8582566,
    y: 29.1754723,
    width: 9.95483672,
    height: 18.0325934,
    rx: 2.0412
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7441407,29.5605229 L68.9097674,29.5605229 C69.6613165,29.5605229 70.2705674,30.1697738 70.2705674,30.9213229 L70.2705674,34.4415955 L61.3833407,34.4415955 L61.3833407,30.9213229 C61.3833407,30.1697738 61.9925916,29.5605229 62.7441407,29.5605229 Z",
    id: "Rectangle-11",
    fill: "#E7F1F7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7441407,29.5605229 L68.9097674,29.5605229 C69.6613165,29.5605229 70.2705674,30.1697738 70.2705674,30.9213229 L70.2705674,31.8455771 L61.3833407,31.8455771 L61.3833407,30.9213229 C61.3833407,30.1697738 61.9925916,29.5605229 62.7441407,29.5605229 Z",
    id: "Rectangle-11",
    fill: "#71B6FF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1154,31.6386 L70.641,31.6386",
    id: "Line-2",
    stroke: "#153454",
    strokeWidth: 1.0206,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    fill: "#153454",
    fillRule: "nonzero",
    x: 28.7964,
    y: 46.9476,
    width: 24.4944,
    height: 1.09585547,
    rx: 0.547927734
  }), /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(27.263922, 24.345262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    fill: "#12FFCD",
    fillRule: "nonzero",
    x: 0.295309193,
    y: 14.4868734,
    width: 27.5488482,
    height: 4.82093709,
    rx: 1.3608
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy",
    fill: "#B6DBFF",
    x: 0.295309193,
    y: 0.611821825,
    width: 16.302538,
    height: 2.73774855,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-3",
    fill: "#B6DBFF",
    x: 0.295309193,
    y: 4.81203214,
    width: 16.302538,
    height: 2.73774855,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-4",
    fill: "#B6DBFF",
    x: 0.295309193,
    y: 9.01224245,
    width: 16.302538,
    height: 2.73774855,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-2",
    fill: "#E7F1F7",
    x: 18.4861657,
    y: 1.07305985,
    width: 8.7342627,
    height: 10.1226111,
    rx: 1.3608
  })), /*#__PURE__*/React.createElement("g", {
    id: "Content-Copy",
    transform: "translate(62.281515, 35.784788)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12",
    fill: "#12FFCD",
    fillRule: "nonzero",
    x: 0.12812105,
    y: 7.31672093,
    width: 6.93619471,
    height: 2.63396295,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy",
    fill: "#B6DBFF",
    x: 0.0772034382,
    y: 0.39245098,
    width: 3.89995632,
    height: 1.43105308,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-3",
    fill: "#B6DBFF",
    x: 0.0985564752,
    y: 2.58794987,
    width: 3.89995632,
    height: 1.43105308,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-4",
    fill: "#B6DBFF",
    x: 0.0960202907,
    y: 4.78344876,
    width: 3.89995632,
    height: 1.43105308,
    rx: 0.6804
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-12-Copy-2",
    fill: "#E7F1F7",
    x: 4.76627294,
    y: 0.329601787,
    width: 2.35003332,
    height: 5.86756992,
    rx: 0.6804
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.9388337,19.4103 L63.1280845,19.4103",
    id: "Line",
    stroke: "#153454",
    strokeWidth: 1.0206,
    fill: "#FFFFFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.a9813d736034ddb45b2522920268556f.svg";
export { ForwardRef as ReactComponent };